import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_socials = (id) => {
  return instance.get(`/v1/mngr/social/${id}`, { headers });
};

export const post_social = (data) => {
  return instance.post(`/v1/mngr/social`, data, { headers });
};

export const put_social = (data) => {
  return instance.put(`/v1/mngr/social`, data, { headers });
};

export const delete_social = (id) => {
  return instance.delete(`/v1/mngr/social/${id}`, { headers });
};
